import { Link } from 'react-router-dom';
import { buttonVariants } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="font-display text-display-lg font-extrabold text-gradient">404</p>
      <h1 className="mt-2 font-display text-2xl font-bold text-ink">This page wandered off.</h1>
      <p className="mt-3 max-w-md text-ink-muted">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link to="/" className={buttonVariants({ variant: 'primary', size: 'lg', className: 'mt-7' })}>
        Back home
      </Link>
    </div>
  );
}
